"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../hooks");

var _carouselSection = require("./carouselSection.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Testimonials = function Testimonials(_ref) {
  var delay = _ref.delay,
      title = _ref.title,
      showPagination = _ref.showPagination,
      children = _ref.children;

  var _useCarousel = (0, _hooks.useCarousel)(delay),
      carouselProps = _useCarousel.carouselProps,
      Carousel = _useCarousel.Carousel,
      PaginationDots = _useCarousel.PaginationDots;

  return /*#__PURE__*/_react["default"].createElement(_carouselSection.Wrapper, {
    variant: "full"
  }, title ? /*#__PURE__*/_react["default"].createElement(_carouselSection.Title, null, title) : null, /*#__PURE__*/_react["default"].createElement(Carousel, _extends({}, carouselProps, {
    Wrapper: _carouselSection.CarouselWrapper
  }), children), showPagination ? /*#__PURE__*/_react["default"].createElement(_carouselSection.PaginationWrapper, null, /*#__PURE__*/_react["default"].createElement(PaginationDots, carouselProps)) : null);
};

Testimonials.propTypes = {
  title: _propTypes["default"].string,
  delay: _propTypes["default"].number.isRequired,
  showPagination: _propTypes["default"].bool
};
var _default = Testimonials;
exports["default"] = _default;